module.exports = require('./RadialProgressBar.vue')



//////////////////
// WEBPACK FOOTER
// ./~/vue-radial-progress/src/main.js
// module id = 321
// module chunks = 0